import React, {useContext, useEffect} from 'react'
import {OfferEditContext} from "../../../context/OfferUpdateContext";
import {Form, Input} from "antd";
import {replaceIndexAt} from "../../../utils/helpers/commonFunctions";

const OfferUpdateDeadline = ({rowIndex, record}) => {

    const [form] = Form.useForm()
    const {bidContent} = useContext( OfferEditContext)
    const [bidList, setBidList] = bidContent

    useEffect(() => {
        if (record.deadline) {
            form.setFieldsValue({[`deadline-${rowIndex}`]: record.deadline})
        }
    }, [rowIndex, record])

    const handleDeadlineChange = ({target}) => {
        const createNewList = replaceIndexAt(
            bidList,
            {
                ...record,
                deadline: target.value
            },
            rowIndex
        )
        setBidList(createNewList)
    }

    return(
        <React.Fragment>
            <Form form={form}>
                <Form.Item name={`deadline-${rowIndex}`}>
                    <Input style={{maxWidth: '100px'}} onBlur={handleDeadlineChange} />
                </Form.Item>
            </Form>
        </React.Fragment>
    )
}
export default OfferUpdateDeadline